import { mapState } from 'vuex'
import ReportTable from '@/components/reports/table/ReportTable.vue'
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'
import ClientPicker from '@/components/client/picker/ClientPicker.vue'
import TableFilter from '@/components/common/tablefilter/TableFilter.vue';

export default {
  name: 'SummaryReports',
  data () {
    return {
      isMounted: false,
      filterValues: {
        reportName: 'I',
        reportType: 'PLACED',
        materialGroups: [],
        fromDatePeriod: '2024010',
        toDatePeriod: '2024010',
        useGenerated: [1],
        grouping: [],
        client: null,
        discountTypes: [],
        minDiscount: '',
        materials: [],
        clientCategories: [],
        managers: [],
        precision: 2,
        multiply: 1,
        reportDataCols: ['VALUE'],
        exportCols: [],
        groupMode: 'PERIOD',
        multiaddMaterialId: null,
        splitByClient: 0
      },
      recheckMaterials: 1,
      reportFilterValues: null,
      downloading: false,
      reportData: null,
      currentReq: null,
      loading: false,
      exportCols: null,
      multiaddMaterials: []
    };
  },
  components: {
    ClientPicker,
    ReportTable,
    DatePeriodPicker,
    TableFilter
  },
  computed: {
    ...mapState(['config']),
    measureTypes () {
      const items = {};
      for (const idx in this.config.measure_types) {
        items[idx] = {
          code: this.config.measure_types[idx].code,
          name: this.BasicHelper.getTranslation(this.config.measure_types[idx].name)
        };
      }
      return items;
    },
    summaryReportPage () {
      if (this.$route.path === '/reports/material') {
        return 1;
      }
      return 0;
    },
    requestPath () {
      let reqestPath = null;
      if (this.filterValues.reportType === 'PLACED') {
        if (this.filterValues.reportName && this.filterValues.fromDatePeriod && this.filterValues.toDatePeriod) {
          reqestPath = 'report/by-code/' + this.filterValues.reportName + '/' + this.filterValues.fromDatePeriod + '/' + this.filterValues.toDatePeriod;
          reqestPath += '?useGenerated=' + (this.filterValues.useGenerated.length > 0 ? 1 : 0);
          if (this.filterValues.client) {
            reqestPath += '&clientApiId=' + this.filterValues.client.api_id;
          }
          reqestPath += '&multiply=' + this.filterValues.multiply + '&precision=' + this.filterValues.precision;
        }
      } else if (this.filterValues.reportType === 'RATES') {
        if (this.filterValues.fromDatePeriod) {
          reqestPath = 'material/material/rates?datePeriodId=' + this.filterValues.fromDatePeriod;
          if (this.filterValues.materialGroups.length > 0) {
            reqestPath += '&materialGroups=' + this.filterValues.materialGroups.join(';');
          }
          if (this.filterValues.discountTypes.length > 0) {
            reqestPath += '&discountTypes=' + this.filterValues.discountTypes.join(';');
          }
          if (this.filterValues.materials.length > 0) {
            reqestPath += '&materials=' + this.filterValues.materials.map(val => val.code).join(';');
          }
          if (this.filterValues.managers.length > 0) {
            reqestPath += '&managers=' + this.filterValues.managers.join(';');
          }
          if (this.filterValues.clientCategories.length > 0) {
            reqestPath += '&clientCategories=' + this.filterValues.clientCategories.join(';');
          }
          const minDiscount = parseFloat(this.filterValues.minDiscount);
          if (minDiscount > 0) {
            reqestPath += '&minDiscount=' + minDiscount;
          }
          if (this.filterValues.client) {
            reqestPath += '&clientApiId=' + this.filterValues.client.api_id;
          }
        }
      } else if (['CLIENT_PLACED', 'CLIENT_MULTIADD'].includes(this.filterValues.reportType)) {
        let reportName = this.filterValues.reportName;
        let reportType = 'multiadd-by-clients';
        if (this.filterValues.reportType == 'CLIENT_PLACED') {
          reportType = 'summary-by-clients';
          if (this.filterValues.grouping.includes('BY_MATERIAL_GROUP')) {
            reportName = 'ALL';
          }
        } else {
          reportName = this.filterValues.multiaddMaterialId;
        }
        if (reportName && this.filterValues.fromDatePeriod && this.filterValues.toDatePeriod) {
          reqestPath = 'report/' + reportType + '/' + reportName + '/' + this.filterValues.fromDatePeriod + '/' + this.filterValues.toDatePeriod + '?';
          if (this.filterValues.materials.length > 0) {
            reqestPath += '&materials=' + this.filterValues.materials.map(val => val.code).join(';');
          }
          if (this.filterValues.managers.length > 0) {
            reqestPath += '&managers=' + this.filterValues.managers.join(';');
          }
          if (this.filterValues.clientCategories.length > 0) {
            reqestPath += '&clientCategories=' + this.filterValues.clientCategories.join(';');
          }

          if (this.filterValues.reportType == 'CLIENT_PLACED') {
            reqestPath += '&multiply=' + this.filterValues.multiply + '&precision=' + this.filterValues.precision;
            if (this.filterValues.grouping.includes('YEARLY')) {
              reqestPath += '&yearly=1';
            }
            if (this.filterValues.grouping.includes('BY_MATERIAL_GROUP')) {
              reqestPath += '&byMaterialGroup=1';
            }
            if (this.filterValues.reportDataCols) {
              reqestPath += '&reportDataCols=' + this.filterValues.reportDataCols.join(';');
            }
          } else {
            reqestPath += '&groupMode=' + this.filterValues.groupMode + '&splitByClient=' + this.filterValues.splitByClient;
          }
        }
      }
      return reqestPath;
    },
    managerOptions () {
      const options = this.$store.getters.getConfigOptions('managers');
      return options;
    },
    materialGroupOptions () {
      const items = this.$store.getters.getItemsFromConfigWithFilter('report_configs');
      if (items) {
        const materialGroupIds = [];
        for (const key in items) {
          materialGroupIds.push(parseInt(items[key].contract_material_group_id));
        }
        return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale)
          .filter(item => materialGroupIds.includes(parseInt(item.value)));
      }
      return [];
    },
    multiplyOptions () {
      return [
        { code: 1, text: this.$t('measure_types.multiply.1') },
        { code: 1000, text: this.$t('measure_types.multiply.1000') }
      ];
    },
    reportTypeOptions () {
      const options = [];
      if (this.summaryReportPage === 1) {
        options.push({ code: 'PLACED', text: this.$t('report.type.placed') });
        options.push({ code: 'CLIENT_PLACED', text: this.$t('report.type.client_placed') });
        options.push({ code: 'CLIENT_MULTIADD', text: this.$t('report.type.client_multiadd') });
        options.push({ code: 'RATES', text: this.$t('report.type.rates') });
      }
      return options;
    },
    reportNameOptions () {
      return this.ZPFormatHelper.getReportNameOptions(true);
    },
    materialOptions () {
      if (this.recheckMaterials);
      const fromPeriodId = parseInt(this.filterValues.fromDatePeriod);
      let toPeriodId = parseInt(this.filterValues.toDatePeriod);
      if (this.filterValues.reportType === 'RATES') {
        toPeriodId = fromPeriodId;
      }
      const items = Object.values(this.config.materials).filter(el => {
        return ((el.deleted === false) && (el.disabled == 0) && (el.from_date_period_id <= toPeriodId) && (el.to_date_period_id === null || el.to_date_period_id >= fromPeriodId));
      });
      const options = {};
      const self = this;
      items.forEach(function (el) {
        let categoryName = '';
        if (el.material_category_id) {
          categoryName = self.ZPFormatHelper.getConfigValuePeriod(
            'material_categories',
            'id', el.material_category_id,
            'name',
            true,
            toPeriodId
          ) + ': ';
        }
        if (!options[el.material_group_id]) {
          options[el.material_group_id] = [];
        }
        const elName = self.ZPFormatHelper.getConfigValuePeriod('materials', 'id', el.id, 'name', true, toPeriodId);
        options[el.material_group_id].push({
          value: el.id,
          text: categoryName + elName,
          html: (categoryName ? '<b>' + categoryName + '</b>' : '') + elName,
          code: el.code
        });
      });
      return options;
    },
    reportGroupingOptions () {
      return [
        { code: 'YEARLY', text: this.$t('report.yearlyReport') },
        { code: 'BY_MATERIAL_GROUP', text: this.$t('report.byMaterialGroup') }
      ];
    },
    filters () {
      const filters = {};
      filters.reportType = { type: 'select', label: this.$t('report.type.title'), options: this.reportTypeOptions, class: 'col-md-3' };
      if (this.summaryReportPage === 1) {
        if (['PLACED', 'CLIENT_PLACED'].includes(this.filterValues.reportType)) {
          if (this.filterValues.reportType === 'PLACED') {
            filters.reportName = { type: 'select', label: this.$t('report.title'), options: Object.values(this.reportNameOptions), class: 'col-md-3' };
            filters.reportDataCols = { type: 'checkbox', label: this.$t('report.datacol.title'), options: this.reportDataColOptions, class: 'col-md-3' };
            filters.useGenerated = { type: 'checkbox', label: this.$t('report.useGeneratedReports'), options: [{ code: 1, text: this.$t('general.yes') }], class: 'col-md-3' };
            filters.client = { type: 'clientpicker', label: '' };
            filters.fromDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-from'), class: 'col-md-2' };
            filters.toDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-to'), class: 'col-md-2' };
          } else {
            filters.reportName = { type: 'select', label: this.$t('report.title'), options: Object.values(this.reportNameOptions), class: 'col-md-3', disabled: (this.filterValues.grouping.includes('BY_MATERIAL_GROUP')) };
            filters.reportDataCols = { type: 'checkbox', label: this.$t('report.datacol.title'), options: this.reportDataColOptions, class: 'col-md-3' };
            filters.clientCategories = { type: 'checkbox', label: this.$t('client.category'), options: this.clientCategoryOptions, class: 'col-md-3' };
            filters.managers = { type: 'checkbox', label: this.$t('client.manager'), options: this.managerOptions, valueField: 'value', class: 'col-md-6' };
            filters.grouping = { type: 'checkbox', label: this.$t('report.grouping'), options: this.reportGroupingOptions, class: 'col-md-2' };
            filters.fromDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-from'), class: 'col-md-2' };
            filters.toDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-to'), class: 'col-md-2' };
            filters.materials = { type: 'searchchecklist', label: '', elname: 'material', nameParam: 'text', keyParam: 'code', options: this.materialOptions, class: 'col-md-8', groupConfigKey: 'material_groups', colsm: 6 };
          }
          filters.multiply = { type: 'select', label: this.$t('measure_types.multiply.title'), options: this.multiplyOptions, class: 'col-md-2' };
          filters.precision = { type: 'number', label: this.$t('report.precision'), class: 'col-md-2' };
        } else if (this.filterValues.reportType === 'CLIENT_MULTIADD') {
          filters.multiaddMaterialId = { type: 'select', label: this.$t('material.title'), options: this.multiaddMaterials, class: 'col-md-3' };
          filters.groupMode = { type: 'radio', label: this.$t('report.groupmode.title'), options: this.groupModeOptions, class: 'col-md-2' };
          filters.splitByClient = { type: 'radio', label: this.$t('report.splitByClient'), options: this.yesNoOptions, class: 'col-md-1' };
          filters.clientCategories = { type: 'checkbox', label: this.$t('client.category'), options: this.clientCategoryOptions, class: 'col-md-3' };
          filters.managers = { type: 'checkbox', label: this.$t('client.manager'), options: this.managerOptions, valueField: 'value', class: 'col-md-6' };
          filters.fromDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-from'), class: 'col-md-2' };
          filters.toDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-to'), class: 'col-md-2' };
        } else {
          filters.materialGroups = { type: 'checkbox', label: this.$t('material-group.title'), options: this.materialGroupOptions, class: 'col-md-3' };
          filters.discountTypes = {
            type: 'checkbox',
            label: this.$t('material_rate.discountTypes'),
            options: [{ code: 'CLIENTRATE', text: this.$t('material_rate.hasClientRate') }, { code: 'PRODUCTDISC', text: this.$t('material_rate.hasProductDiscount') }],
            class: 'col-md-3'
          };
          filters.clientCategories = { type: 'checkbox', label: this.$t('client.category'), options: this.clientCategoryOptions, class: 'col-md-3' };
          filters.managers = { type: 'checkbox', label: this.$t('client.manager'), options: this.managerOptions, valueField: 'value', class: 'col-md-8' };
          filters.fromDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period'), class: 'col-md-2', allPeriods: true };
          filters.minDiscount = { type: 'number', label: this.$t('material_rate.minDiscount'), class: 'col-md-2' };
          filters.materials = { type: 'searchchecklist', label: '', elname: 'material', nameParam: 'text', keyParam: 'code', options: this.materialOptions, class: 'col-md-12', groupConfigKey: 'material_groups', colsm: 6 };
        }
      }
      return filters;
    },
    tableClass () {
      if (this.reportFilterValues.reportType === 'RATES') {
        return 'sticky-header';
      }
      return '';
    },
    tableHeaders () {
      const headers = [];
      if (this.reportFilterValues.reportType === 'RATES') {
        headers.push({ key: 'clientName', label: this.$t('client.name'), type: 'routelink', routeTo: 'menu.client.edit', params: { clientApiId: 'clientApiId' }, sortable: true, localFilter: true });
        headers.push({ key: 'material_id', label: this.$t('material.title'), type: 'slot', slotcode: 'materials', sortable: true, localFilter: true, searchFunc: this.getMaterialFilterTxt });
        headers.push({ key: 'defaultRate', label: this.$t('material.defaultRate'), format: 'formatDecimal', precision: 4, sortable: true });
        headers.push({ key: 'clientRate', label: this.$t('material.clientRate'), format: 'formatDecimal', precision: 4, sortable: true });
        headers.push({ key: 'discount', label: this.$t('material-group.discount'), format: 'formatPercent', sortable: true });
        headers.push({ key: 'activeDiscount', label: this.$t('material.activeDiscount'), format: 'formatPercent', sortable: true });
        headers.push({ key: 'isAllowed', label: this.$t('material_rate.isAllowed'), format: 'formatYesNo', sortable: true });
        headers.push({ key: 'activeRate', label: this.$t('material.activeRate'), format: 'formatDecimal', precision: 4, sortable: true });
        headers.push({ key: 'manager_id', label: this.$t('client.manager'), format: 'formatFromConfig', configKey: 'managers', configParam: 'name', sortable: true, localFilter: true });
      } else if (this.reportFilterValues.reportType === 'CLIENT_PLACED' && this.reportData && this.reportData[0]) {
        headers.push({ key: 'clientName', label: this.$t('client.name'), class: 'sticky-col', type: 'routelink', routeTo: 'menu.client.edit', params: { clientApiId: 'clientApiId' }, sortable: true, localFilter: true })
        headers.push({ key: 'axaptCode', label: this.$t('client.axaptCode'), localFilter: true })
        const self = this;
        let prevPeriod = null;
        let prevMaterial = null;
        const extraHeaders = [[{ label: '', colspan: 2 }], [{ label: '', class: 'border-right', colspan: 2 }]];
        let materialCount = 0;
        let colCount = 0;
        Object.keys(this.reportData[0]).forEach(elKey => {
          const elKeys = elKey.split('_');
          if (elKeys[elKeys.length - 1] === 'SUBMITTED') {
            return;
          }
          let material = null;
          if (this.reportFilterValues.grouping.includes('BY_MATERIAL_GROUP')) {
            material = self.$store.getters.getDataFromConfigById('material_groups', elKeys[1]);
          } else {
            material = self.$store.getters.getDataFromConfigById('materials', elKeys[1]);
          }
          let measureType = null;
          if (elKeys[3]) {
            measureType = self.$store.getters.getDataFromConfigById('measure_types', elKeys[3]);
          }
          if (material) {
            let elClass = '';
            if (prevMaterial === null || prevMaterial.code !== material.code) {
              if (colCount > 1) {
                elClass += ' border-left';
              }
              if (prevMaterial) {
                let materialClass = 'text-center sticky-header';
                if (colCount > 1 || prevPeriod !== elKeys[0]) {
                  materialClass += ' border-right';
                }
                extraHeaders[1].push({
                  class: materialClass,
                  colspan: colCount,
                  label: self.ZPFormatHelper.getConfigValuePeriod('materials', 'id', prevMaterial.id, 'name', true, self.filterValues.toDatePeriod)
                });
              }
              colCount = 0;
              prevMaterial = self.BasicHelper.cloneObject(material);
            }
            if (prevPeriod !== elKeys[0]) {
              elClass += ' border-left';
              if (prevPeriod) {
                const datePer = self.BasicHelper.datePeriodCodeToData(prevPeriod);
                extraHeaders[0].push({
                  class: 'text-center border-left',
                  colspan: materialCount,
                  label: (datePer ? self.$tc('general.datePeriod.short', datePer.period, datePer) : '')
                });
              }
              materialCount = 0;
              prevPeriod = elKeys[0];
            }
            let measureTypeName = '';
            if (measureType) {
              measureTypeName = self.BasicHelper.getTranslation(measureType.name);
              if (this.reportFilterValues.multiply === 1000) {
                if (measureType.code === 'KG') {
                  measureTypeName = self.BasicHelper.getTranslation(
                    self.$store.getters.getParamFromConfigByFilter('measure_types', 'code', 'T', 'name')
                  );
                } else {
                  measureTypeName = self.reportFilterValues.multiply + ' ' + measureTypeName;
                }
              }
            }
            let elLabel = measureTypeName;
            let elPrecision = (self.filterValues.precision ? parseInt(self.filterValues.precision) : 0);
            if (elKeys[2] === 'RATE') {
              elLabel = self.$t('general.currency') + ' / ' + measureTypeName;
              elPrecision = 3;
            } else if (elKeys[2] === 'CURRENCY') {
              elLabel = self.$t('general.currency');
              elPrecision = 2;
            }
            headers.push({
              key: elKey,
              label: elLabel,
              format: 'formatDecimal',
              precision: elPrecision,
              decimalFloor: true,
              class: elClass,
              sortable: true,
              classfunc: this.isFilledInReport
            });
            materialCount += 1;
            colCount += 1;
          }
        });
        extraHeaders[0].push({ class: 'text-center border-left', colspan: materialCount, label: self.$t('general.total') });
        if (prevMaterial) {
          extraHeaders[1].push({ class: 'text-center sticky-header', colspan: colCount, label: self.BasicHelper.getTranslation(prevMaterial.name) });
        }
        headers[0].extraHeaders = extraHeaders;
      } else if (this.reportFilterValues.reportType === 'CLIENT_MULTIADD') {
        if (this.reportFilterValues.splitByClient == 1) {
          headers.push({ key: 'clientName', label: this.$t('client.name'), class: 'sticky-col', type: 'routelink', routeTo: 'menu.client.edit', params: { clientApiId: 'clientApiId' }, sortable: true, localFilter: true });
          headers.push({ key: 'axaptCode', label: this.$t('client.axaptCode'), localFilter: true });
        }
        if (this.reportFilterValues.groupMode == 'YEAR') {
          headers.push({ key: 'year', label: this.$t('general.filters.year'), localFilter: true, sortable: true });
        } else if (this.reportFilterValues.groupMode == 'NONE' || this.reportFilterValues.groupMode == 'PERIOD') {
          headers.push({ key: 'period_id', label: this.$t('general.filters.date-period'), format: 'formatDatePeriod', localFilter: true, sortable: true })
        }
        headers.push({ key: 'density', label: this.$t('report.multiadd.columns.density'), format: 'formatDecimal', sortable: true })
        headers.push({ key: 'weight', label: this.$t('report.multiadd.columns.weight', this.multiaddMeasureTrans), format: 'formatDecimal', sortable: true })
        headers.push({ key: 'quantity', label: this.$t('report.multiadd.columns.quantity', this.multiaddMeasureTrans), format: 'formatDecimal', sortable: true })
        headers.push({ key: 'weight_one', label: this.$t('report.multiadd.columns.weightPerOne', this.multiaddMeasureTrans), format: 'formatDecimal', sortable: true, precision: 6 })
      }
      return headers;
    },
    clientCategoryOptions () {
      const options = this.$store.getters.getConfigOptions('client_categories', this.$i18n.locale);
      options.unshift({ text: this.$t('general.filters.without'), code: 'NULL' });
      return options;
    },
    reportDataColOptions () {
      return [
        { code: 'VALUE', text: this.$t('report.datacol.value') },
        { code: 'CURRENCY', text: this.$t('report.datacol.currency') },
        { code: 'RATE', text: this.$t('report.datacol.rate') }
      ];
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    groupModeOptions () {
      return [
        { code: 'NONE', text: this.$t('report.groupmode.NONE') },
        { code: 'PERIOD', text: this.$t('report.groupmode.PERIOD') },
        { code: 'YEAR', text: this.$t('report.groupmode.YEAR') },
        { code: 'ALL', text: this.$t('report.groupmode.ALL') }
      ];
    },
    multiaddMeasureTrans () {
      let measureTypeId = null;
      if (this.multiaddMaterials && this.filterValues.multiaddMaterialId) {
        const el = this.multiaddMaterials.find(el => el.code == this.filterValues.multiaddMaterialId);
        if (el) {
          measureTypeId = this.$store.getters.getParamFromConfigByFilter('materials', 'id', el.item.material_id, 'measure_type_id');
        }
      }
      return {
        measuretypeW: this.$store.getters.getParamFromConfigByFilter('measure_types', 'id', measureTypeId, 'name')[this.$i18n.locale],
        measuretypeQ: this.$store.getters.getParamFromConfigByFilter('measure_types', 'code', 'GAB', 'name')[this.$i18n.locale]
      }
    }
  },
  methods: {
    filtersUpdated (value, key) {
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      if (((key === 'toDatePeriod') || (key === 'fromDatePeriod')) && this.$refs.tablefiltermaterials) {
        this.recheckMaterials = (this.recheckMaterials + 1) % 100;
        this.$refs.tablefiltermaterials.forEach(el => {
          el.updateItems(this.materialOptions);
        })
      }
    },
    getNameFromConfig (configEl, value) {
      return this.$options.filters.formatFromConfig(value, this.config[configEl], 'name', this.$i18n.locale);
    },
    reloadReport () {
      this.getReport();
    },
    getReport () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      const self = this;
      const reportType = this.filterValues.reportType;
      if (this.requestPath) {
        this.reportData = {};
        this.loading = true;
        const reqFileters = this.BasicHelper.cloneObject(this.filterValues);
        this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, [], function (response) {
          if (response.data) {
            if (reportType === 'PLACED') {
              self.ReportHelper.setParams(self.$options.filters, self);
              const precision = (self.filterValues.precision ? parseInt(self.filterValues.precision) : 0);
              self.reportData = self.ReportHelper.createReportData(response.data, true, null, precision, true, self.filterValues.reportDataCols);
            } else {
              self.reportData = response.data;
            }
            self.reportFilterValues = reqFileters;
            self.loading = false;
          } else {
            self.reportData = null;
          }
        });
      }
    },
    downloadReports (paramSelected) {
      if (this.filterValues.reportType === 'PLACED' && this.reportData) {
        const tableData = {};
        const refs = this.$refs.reportTable;
        if (refs) {
          if (refs.innerHTML) {
            tableData[0] = refs.innerHTML;
          } else {
            refs.forEach((el, key) => {
              tableData[key] = el.$el.innerHTML;
            });
          }
        }
        this.BasicHelper.tablesToExcelFile(tableData, 'ZP_' + this.filterValues.reportType + (new Date()).toISOString());
      } else {
        if (!paramSelected && this.exportCols) {
          this.$refs.searchchecklist.showModal();
        } else {
          const self = this;
          this.downloading = true;
          this.ApiRequest.request(this.requestPath + '&download=1', this.ApiRequest.REQUEST_DOWNLOAD, { cols: this.filterValues.exportCols }, function () {
            self.downloading = false;
          });
        }
      }
    },
    changePage (pageNr) {
      // this.getReport();
    },
    getMaterialName (materialId) {
      const material = this.$store.getters.getDataFromConfigById('materials', materialId);
      if (material) {
        return this.BasicHelper.getTranslation(material.name);
      }
      return ''
    },
    getMaterialMeasureType (materialId) {
      const material = this.$store.getters.getDataFromConfigById('materials', materialId);
      if (material) {
        return this.measureTypes[material.measure_type_id];
      }
      return '';
    },
    isFilledInReport (item, field) {
      if (item[field.key + '_SUBMITTED']) {
        return '';
      }
      return 'error-intense  font-weight-bold';
    },
    loadExportCols () {
      const self = this;
      this.ApiRequest.request('report/export-columns/client_placed', this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          const colConfig = [];
          response.data.forEach(el => {
            colConfig.push({ key: el.key, name: self.$t(el.key), group: el.group });
          });
          self.exportCols = colConfig;
        }
      })
    },
    loadMultiaddMaterials () {
      const self = this;
      this.ApiRequest.request('report/multiadd-materials', this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          response.data.forEach(el => {
            self.multiaddMaterials.push({
              code: el.id,
              text: self.BasicHelper.getTranslation(self.$store.getters.getParamFromConfig('materials', el.material_id, 'name')),
              item: el
            })
          });
        }
        self.filterValues = self.BasicHelper.fillFilterValues(self.$route.name, self.filterValues, self.$session);
        if (self.multiaddMaterials && !self.filterValues.multiaddMaterialId) {
          self.filterValues.multiaddMaterialId = self.multiaddMaterials[0].code;
        }
        self.isMounted = true;
      })
    },
    getMaterialFilterTxt (text, el) {
      return this.ZPFormatHelper.getConfigValuePeriod('materials', 'id', el.material_id, 'name', true, this.filterValues.fromDatePeriod);
    }
  },
  mounted () {
    this.loadExportCols();
    this.loadMultiaddMaterials();
  }
}
